import React from 'react';
import {containerStyles} from "./LandingPageContent.css";
import ContentSection from "./ContentSection";

const LandingPageContent = (props) => {
    return (
      <div style={containerStyles}>
        <div className={"container"}>
          <div className={"row justify-content-center"}>
            <ContentSection title={"Exciting steps forward!"} text={"With this single login, jump from one Lone Wolf product to another—with the same username and password! Enjoy a more unified product experience."}
                            buttonText={"Learn More"} buttonLinkDestination={"https://www.lwolf.com"}/>
            <ContentSection title={"Coming soon...."} text={"We can’t wait to tell you all of the awesome things we’re working on. While we can’t spill the beans on everything just yet, we put together a preview of what’s coming up."}
                            buttonText={"What's next"} buttonLinkDestination={"https://www.lwolf.com/about/news-press"}/>
            <ContentSection title={"Need help?"} text={"We’ve got you covered. With The Community, live training sessions, and our amazing Support team, we’re here to help you make the most of your Lone Wolf experience."}
                            buttonText={"Get help"} buttonLinkDestination={"https://www.lwolf.com/support"}/>
          </div>
        </div>
      </div>
    );
};

LandingPageContent.propTypes = {
};

export default LandingPageContent;